import { render, staticRenderFns } from "./GruposDia.vue?vue&type=template&id=be6a1080&scoped=true&"
import script from "./GruposDia.vue?vue&type=script&lang=js&"
export * from "./GruposDia.vue?vue&type=script&lang=js&"
import style0 from "./GruposDia.vue?vue&type=style&index=0&id=be6a1080&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be6a1080",
  null
  
)

export default component.exports